import { useQuery } from '@tanstack/react-query';
import { getCommunityFees } from '../Redux/util/Apis/fees';

export const useFees = (options = {}) => {
  const { clientId, communityId } = options;

  return useQuery({
    queryKey: ['fees', clientId, communityId],
    queryFn: async () => {
      const result = await getCommunityFees(clientId, communityId);

      if (result?.error) {
        throw new Error(result.message || 'Failed to fetch fees');
      }

      return result?.data || result || [];
    },
    enabled: !!clientId && !!communityId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000
  });
};

export default useFees;
